import { connect } from 'react-redux'
import { selectIsMerging } from 'selectors/page'
import { doOpenTicketMergePage, doOpenTicketPage } from 'actions/pages'
import { selectCurrentTicketId } from 'selectors/tickets'
import View from './view'

const select = state => ({
  ticketId: selectCurrentTicketId(state),
  open: selectIsMerging(state),
})

const perform = dispatch => ({
  onOpen: ticketId => dispatch(doOpenTicketMergePage(ticketId)),
  onClose: ticketId => dispatch(doOpenTicketPage(ticketId)),
})

export default connect(select, perform)(View)
